import React, { useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";

import { Status } from "../../../@types/status";

import { closeOutline } from "ionicons/icons";
import { selectDocumentsStatus } from "../../../store/utils/selectors/selectDocumentsStatus";
import { selectStatusFilter } from "../../../store/documentsSignerList/selectors/selectStatusFilter";
import { selectFilterByStatusModal } from "../../../store/documentsSignerList/selectors/selectFilterByStatusModal";
import { setFilterByStatusModal, setStatusFilter } from "../../../store/documentsSignerList";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";

export const FilterStatusSelector: React.FC = () => {
  const dispatch = useDispatch();

  const allStatus = useSelector(selectDocumentsStatus);
  const statusFilter = useSelector(selectStatusFilter);
  const showModal = useSelector(selectFilterByStatusModal);

  const [statusFormData, setStatusFormData] = useState<Status[]>([]);
  const initFormData = () => {
    setStatusFormData(
      allStatus.map((statusItem) => ({
        ...statusItem,
        checked: !!statusFilter?.find(({ id }) => id === statusItem.id),
      }))
    );
  };

  const hangleCheck = (statusChecked: Status) => {
    setStatusFormData(
      statusFormData.map((statusItem) => ({
        ...statusItem,
        checked: statusChecked.id === statusItem.id ? !statusItem.checked : statusItem.checked,
      }))
    );
  };

  const applyFilter = async () => {
    dispatch(setStatusFilter(statusFormData.filter(({ checked }) => checked)));
    dispatch(setFilterByStatusModal(false));
    dispatch(fetchDocuments());
  };

  const resetStatusFilter = () => {
    dispatch(setStatusFilter([]));
    dispatch(setFilterByStatusModal(false));
    dispatch(fetchDocuments());
  };

  return (
    <>
      <IonModal
        isOpen={showModal}
        onWillPresent={initFormData}
        onDidDismiss={() => dispatch(setFilterByStatusModal(false))}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por estado</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setFilterByStatusModal(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            <IonListHeader>Estados</IonListHeader>
            {statusFormData
              .filter((status) => status.id == 2 || status.id == 3 || status.id == 7)
              .map((statusItem: Status, index: number) => (
                <IonItem key={index}>
                  <IonLabel>{statusItem.name}</IonLabel>
                  <IonCheckbox
                    slot="end"
                    checked={statusItem.checked}
                    onIonChange={() => hangleCheck(statusItem)}
                  />
                </IonItem>
              ))}
          </IonList>
        </IonContent>
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton color="danger" fill="solid" onClick={resetStatusFilter}>
                Limpiar filtro
              </IonButton>
              <IonButton color="primary" fill="solid" onClick={applyFilter}>
                Aplicar filtro
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </>
  );
};
